import { render, staticRenderFns } from "./ProjectionsTable.vue?vue&type=template&id=728794e4&scoped=true&"
import script from "./ProjectionsTable.vue?vue&type=script&lang=js&"
export * from "./ProjectionsTable.vue?vue&type=script&lang=js&"
import style0 from "./ProjectionsTable.vue?vue&type=style&index=0&id=728794e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../home/ubuntu/albert_frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728794e4",
  null
  
)

export default component.exports